var MAIN_EDITOR;
function initializeEditor(editorId){
  var editor = ace.edit(document.getElementById(editorId));

  editor.getSession().setMode("ace/mode/python");
  editor.renderer.setScrollMargin(10, 10);
  editor.$blockScrolling = Infinity;

  editor.setOptions({
      // Editor options
      selectionStyle: 'line',
      highlightActiveLine: true,
      cursorStyle: 'smoth',
      // Renderer options
      showInvisibles: true,
      showPrintMargin: true,
      fontSize: '12px',
      theme: 'ace/theme/tomorrow_night', // 'ace/theme/monokai',
      // Session options
      useSoftTabs: true,
      tabSize: 4,
      wrap: true,
      indentedSoftWrap: false,
      // Editor options defined by extensions
      enableMultiselect: true,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      enableSnippets: true
  });

  return editor;
}

(function($){
  $(function(){
    document.addEventListener('keydown', checkKeyDown);

    // Keyboard shortcuts
    function checkKeyDown(evt) {
      evt = evt || window.event;

      var ctrlKeyIsPressed = evt.ctrlKey;
      var actualKeyPressed = evt.code;

      switch (true) {
        case (ctrlKeyIsPressed && actualKeyPressed === 'KeyR'):
          // Ctrl + R
          evt.preventDefault();
          tryCode();
          break;
        case (ctrlKeyIsPressed && actualKeyPressed === 'Enter'):
          // Ctrl + Enter
          submitCode();
          break;
      }
    }

    var extraPythonCode = $('script[type="text/template+python"]').text();
    var editor = initializeEditor("assignment-main");
    var lessonIsDone
    MAIN_EDITOR = editor;

    var editorHasChanged;
    editor.on('change', function(e) {
      if (!editorHasChanged && !lessonIsDone) {

        window.onbeforeunload = confirmExit;
        function confirmExit() {
          return 'Warning: Changes you made may asdadaddnot be saved';
        }

        editorHasChanged = true;
      }
    });
    // Code Execution
    var FLAVOR = 'ds-3.6';
    var EXECUTOR_URL = LEARN_JS_APP.CODE_EXECUTOR_URL;
    var ASSIGNMENT_ATTEMPT_URL = '/api/v1/assignments/attempts';

    var $mainForm = $('form.js-assignment-code-wrapper');
    var $submitCodeButton = $('.js-assignment-submit-code-button');
    var $tryCodeButton = $('.js-assignment-try-code-button');
    var $tryTestButton = $('.js-assignment-try-test-button');
    var $nextLessonButton = $('.next-lesson-button');
    var $flavorDropdownSelected = $('.console-flavor-selector .dropdown-button');
    var $flavorOption = $('.flavor-option');
    var $tests = $('.js-test-container');
    var lesson_id = $('#description').attr('data-lesson-id');
    var user_id = parseInt($('#description').attr('data-user-id'));

    $flavorOption.on('click', function(evt) {
      var selection = evt.target;

      FLAVOR = selection.attributes['data-flavor'].value;
      $flavorDropdownSelected.html(selection.innerText)
    });

    var resetConsole = () => {
      $('.js-console-output').hide()
    }

    var resetTests = function() {
      $tests.each(function(test) {
        var $testStatus = $(this).find('.status');
        var $testError = $(this).find('.error code');

        $testStatus.removeClass('passed failed loading');
        $testError.hide();
      });
    }

    var executeCompileRequest = function(data) {
      data['files'] = Object.assign(data['files'] || {}, window.LESSON_FILES)
      return fetch(EXECUTOR_URL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
    }

    var postAssignmentAttempt = function(attempt) {
      return fetch(`${ASSIGNMENT_ATTEMPT_URL}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(attempt)
      })
    }

    var getAssignmentAttempts = function(user_id, lesson_id) {
      return fetch(`${ASSIGNMENT_ATTEMPT_URL}?user=${user_id}&lesson=${lesson_id}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin'
      })
    }

    $mainForm.submit(function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    });

    var submitCode = function(evt) {
      if (!$submitCodeButton.length) {
        return;
      }

      resetConsole();

      // loading
      $submitCodeButton.html('<i class="fa fa-refresh fa-spin fa-fw"></i><span class="sr-only"></span>');

      // all tests loading
      $tests.each(function(test) {
        var $testStatus = $(this).find('.status');
        var $testError = $(this).find('.error code');

        $testStatus.removeClass('passed failed').addClass('loading');
        $testError.hide();
      });

      var testsCode = [];
      $tests.each(function(test){
        var code = $(this).find('.test code').attr('data-code');
        testsCode.push(code);
      });

      var data = {
        command: "py.test --json=report.json -q --tb=short tests.py",
        files: {
          'tests.py': extraPythonCode + '\n\n' + editor.getValue() + '\n\n\n' + testsCode.join('\n\n')
        },
        flavor: FLAVOR,
        language: 'python',
        produces: ['report.json']
      }

      executeCompileRequest(data)
      .then(function(res){
        return res.json()
      })
      .then(function(res) {
        var response = JSON.parse(res.files['report.json']);
        var report = response.report;

        $tests.each(function(test) {
          var testName = $(this).find('.title').attr('data-test-function-name');
          var testParsedName = 'tests.py::' + testName;
          var $testStatus = $(this).find('.status');
          var $testError = $(this).find('.error code');

          if (report.tests.length && report.tests.length === $tests.length) {

            var found = false;
            for (var i = 0; i < report.tests.length; i++) {
              var testReport = report.tests[i];
              if (testReport.name === testParsedName) {
                found = true;
                switch (testReport.call.outcome) {
                  case 'failed':
                    $testStatus.removeClass('passed loading').addClass('failed');
                    $testError.html(testReport.call.longrepr);
                    $testError.show();
                    break;
                  case 'passed':
                    $testStatus.removeClass('failed loading').addClass('passed');
                    $testError.hide();
                    break;
                  default:
                    break;
                }
              }
            }
            if(!found){
              console.error("NOT FOUND: " + testParsedName)
            }
          } else {
            $testStatus.removeClass('loading');
            $testError.hide();
          }
        });

        var $consoleContainer = $('.js-console');
        var consoleSelector = '.js-console-output-clean';
        var output = '';

        if (!res.successful){
          consoleSelector = '.js-console-output-error';

          if (!report.tests.length || report.tests.length !== $tests.length) {
            var stdout = res.stdout.split('\n');
            var onlyError = stdout.slice(4, stdout.length - 3).join('\n')

            output = onlyError + '\n\n';
          }
        }
        var summary = report.summary;
        var num_tests = summary.num_tests || '–';
        var passed = summary.passed || '–';
        var failed = summary.failed || '–';
        var duration = summary.duration || '–';
        output += 'TOTAL TESTS RAN: ' + num_tests +
                 '\n PASSED: ' + passed +
                 '\n FAILED: ' + failed +
                 '\n duration: ' + duration;

        var $console = $consoleContainer.find(consoleSelector)
        $console.find('code').text(output);
        $console.show();
        $submitCodeButton.html('Submit Solution');

        var resolved = num_tests === passed && passed > 0;

        var attempt = {
          user_id: user_id,
          lesson_id: lesson_id,
          submitted_code: editor.getValue(),
          resolved: resolved
        }

        postAssignmentAttempt(attempt)
        .then(function(res) {
          getAssignmentAttempts(user_id, lesson_id)
          .then(function(res){
            return res.json()
          })
          .then(function(res) {
            var attempts = res.results

            attempts.forEach(function(attempt) {
              if (attempt.resolved) {
                $nextLessonButton.removeClass('hidden');
                $(`#lesson-${lesson_id}-icon`).removeClass('hidden');

                // disable "stay or leave" message if assigment is done
                lessonIsDone = true;
                window.onbeforeunload = false;
              }

              $('#no-previous-attempts').addClass('hidden');

              // update previous attempts list
              var $currentAttempt = $(`#attempt-${attempt.id}`);

              if (!$currentAttempt[0]) {
                // Add done messages only when it is the first resolved attempt
                if (attempt.resolved && attempts.filter(function(a) { return a.resolved }).length === 1) {
                  $('#lesson-done-message').removeClass('hidden');
                  $('#lesson-done-console-message').css('display', 'inline');
                }

                var $attemptsContainer = $('#attempts-container');
                var $assignmentSourceContainer = $('#assignment-source-container');
                attempt.created = moment(attempt.datetime).utc().format('MMM D, YYYY, h:mm a');

                var newAttempt = `
                  <li id="attempt-${attempt.id}" class="previous-attempt">
                    ${attempt.resolved ?
                      `<i class="fa fa-check" aria-hidden="true"
                      style="width: 15px; color: #009688; text-align: center; margin-right: 5px;"></i>`
                    :
                      `<i class="fa fa-times" aria-hidden="true"
                      style="width: 15px; color: #DD4A68; text-align: center; margin-right: 5px;"></i>`
                    }<a class="waves-effect waves-light modal-trigger js-prompt-previously-solved-assignment"
                    href="#previous-attempt-modal" data-attempt-id="${attempt.id}">
                      ${attempt.resolved ? 'Successful' : 'Failed'}
                      attempt on ${attempt.created} &nbsp;
                    </a>
                  </li>
                `;

                var newAssignmentSource = `
                  <div id="assignment-source-${attempt.id}">
                    <pre class="language-python"><code class="language-python">${attempt.submitted_code}</code></pre>
                  </div>
                  <div id="assignment-source-${attempt.id}-verbatim">
                    ${attempt.submitted_code}
                  </div>
                `;

                var $newAttemptElement = $(newAttempt);
                $attemptsContainer.append($newAttemptElement);


                var $newAssignmentSourceElement = $(newAssignmentSource);
                $assignmentSourceContainer.append($newAssignmentSourceElement);

                var assignmentId = `#assignment-source-${attempt.id}`;
                Prism.highlightElement($(assignmentId).find('code.language-python')[0]);
              }
            });
          });
        })
      });
    }
    $submitCodeButton.on('click', submitCode);

    var tryTest = function(evt) {
      if (!$tryTestButton.length) {
        return;
      }

      resetConsole();

      var $test = $(evt.target).parent().parent();
      var $testStatus = $test.find('.status');
      var $testError = $test.find('.error code');

      $testStatus.removeClass('passed failed').addClass('loading');
      $testError.hide();

      var testCode = $test.find('.test code').attr('data-code');

      var data = {
        command: "py.test --json=report.json -q --tb=short tests.py",
        files: {
          'tests.py': extraPythonCode + '\n\n' + editor.getValue() + '\n\n\n' + testCode
        },
        flavor: FLAVOR,
        language: 'python',
        produces: ['report.json']
      }

      executeCompileRequest(data)
      .then(function(res){
        return res.json()
      })
      .then(function(res) {
        var response = JSON.parse(res.files['report.json']);
        var report = response.report;

        var testName = $test.find('.title').attr('data-test-function-name');
        var testParsedName = 'tests.py::' + testName;
        var $testStatus = $test.find('.status');
        var $testError = $test.find('.error code');

        if (report.tests.length) {
          report.tests.forEach(function(testReport) {
            if (testReport.name === testParsedName) {
              switch (testReport.call.outcome) {
                case 'failed':
                  $testStatus.removeClass('passed loading').addClass('failed');
                  $testError.html(testReport.call.longrepr);
                  $testError.show();
                  break;
                case 'passed':
                  $testStatus.removeClass('failed loading').addClass('passed');
                  $testError.hide();
                  break;
                default:
                  break;
              }
            }
          })
        } else {
          $testStatus.removeClass('loading');
          $testError.hide();
        }

        var $consoleContainer = $('.js-console');
        var output = '';
        var consoleSelector = '.js-console-output-clean';
        if (!res.successful){
          consoleSelector = '.js-console-output-error';

          if (!report.tests.length) {
            var stdout = res.stdout.split('\n');
            var onlyError = stdout.slice(4, stdout.length - 3).join('\n')

            output = onlyError + '\n\n';
          }
        }

        var $console = $consoleContainer.find(consoleSelector)
        $console.find('code').text(output);
        $console.show();
      });
    };
    $tryTestButton.on('click', tryTest);

    var tryCode = function(evt) {
      if (!$tryCodeButton.length) {
        return;
      }

      resetConsole();
      resetTests();

      // loading
      $tryCodeButton.html('<i class="fa fa-refresh fa-spin fa-fw"></i><span class="sr-only"></span>');

      var data = {
        code: editor.getValue(),
        flavor: FLAVOR,
        language: 'python'
      }

      executeCompileRequest(data)
      .then(function(res){
        return res.json()
      })
      .then(function(res) {
        var $consoleContainer = $('.js-console');
        var consoleSelector = '.js-console-output-clean';
        var output = res.stdout;
        if (!res.successful){
          consoleSelector = '.js-console-output-error';
          output = res.stderr;
        }
        var $console = $consoleContainer.find(consoleSelector)
        $console.find('code').text(output);
        $console.show();
        $tryCodeButton.html('Run code');
      });
    };
    $tryCodeButton.on('click', tryCode);

    $(document).on('click', '.js-prompt-previously-solved-assignment', function(evt) {return showAttemptDataModal(evt)});

    var showAttemptDataModal = function(evt) {
      evt.preventDefault();
      var $assignmentsModal = $('#previous-attempt-modal');
      var self = $(evt.target);
      var attemptId = self.data('attempt-id');

      var attemptSource = $('#assignment-source-' + attemptId).html();
      // This is for removal of the spaces before the first line of code
      var lengthBeforeEmptySpace = '            <pre class=" language-python"><code class=" language-python">" '.length;
      var attemptSourceEmptySpaceRemoved = attemptSource.slice(0, lengthBeforeEmptySpace+1) + attemptSource.slice(lengthBeforeEmptySpace).trim()

      var attemptSourceVerbatim = $('#assignment-source-' + attemptId + '-verbatim').text();
      var attemptTitle = self.html();
      $assignmentsModal.find('.modal-header').html('<h3>' + attemptTitle + '</h3>');
      $assignmentsModal.find('.modal-body').html(attemptSourceEmptySpaceRemoved);
      $assignmentsModal.find('a.modal-action:nth-child(2)').on('click', function(evt){
          editor.setValue(attemptSourceVerbatim.trim());
      });
    };
  }); // end of document ready
})(jQuery); // end of jQuery name space
